import React, { useEffect, useState } from 'react';
import SelectInput from '../selectInput/SelectInput';
import { TitleApi } from '../../../api/TitleApi';
import { SelectOpt } from '../CommonTypes';
import { useAuth0 } from '@auth0/auth0-react';
import { useTranslation } from 'react-i18next';

export type SelectTitleInputProps = {
    displayLabel?: string;
    selectedTitle: string;
    onSelectTitle: (selectedValue: string) => void;
};

const SelectTitleInput = ({
    displayLabel = 'Title:',
    selectedTitle,
    onSelectTitle
}: SelectTitleInputProps): JSX.Element => {
    const [titles, setTitles] = useState<SelectOpt[]>([]);

    const { getAccessTokenSilently } = useAuth0();
    const { i18n } = useTranslation();

    const currentLanguage = i18n.language;

    useEffect(() => {
        const loadTitles = async () => {
            const controller = new AbortController();

            const setTitleSuccess = (newTitles: string[]) => {
                const titleOptions: SelectOpt[] = [];

                newTitles.forEach((item, index) => {
                    const lookupOption: SelectOpt = {
                        id: (index + 1).toString(),
                        text: item,
                        value: item,
                        disabled: false
                    };
                    titleOptions.push(lookupOption);
                });

                setTitles(titleOptions);
            };

            const setTitleFailure = (err: string) => {
                console.log(`Get title error: ${err}`);
            };

            const token = await getAccessTokenSilently();

            await new TitleApi().getTitlesAsync(
                token,
                setTitleSuccess,
                setTitleFailure,
                controller.signal,
                currentLanguage
            );

            return () => {
                controller.abort();
            };
        };

        loadTitles();
    }, [currentLanguage]);

    return (
        <div id='select-title-input' className='col-auto'>
            <SelectInput
                label={displayLabel}
                name='title-list'
                forceDefault
                options={titles}
                onChange={onSelectTitle}
                value={selectedTitle}
            />
        </div>
    );
};

export default SelectTitleInput;
